import { useRef } from "react";
import html2pdf from "html2pdf.js";
import moment from "moment";

const useReceiptPrint = () => {
  const receiptRef = useRef(null);

  const triggerReceiptPrint = () => {
    setTimeout(() => {
      const element = receiptRef?.current;
      if (!element) return;
      html2pdf(element, {
        margin: [28, 0, 0, 0],
        filename: `Cash_Receipt_${moment(Date.now()).format(
          "DD_MM_YYYY_HH_mm_ss",
        )}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 100,
          letterRendering: true,
          useCORS: true,
          logging: true,
          scale: 4,
          scrollY: 0,
        },
        jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
        pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
        DisablePdfCompression: true,
      })
        .from(element)
        .outputPdf()
        .get("pdf")
        .then((pdfObj) => {
          pdfObj.autoPrint();
          window.open(pdfObj.output("bloburl"), "F");
        });
    }, 500);
  };

  return { receiptRef, triggerReceiptPrint };
};

export default useReceiptPrint;
